export default "__VITE_ASSET__BasIMqR6__"